import React from "react"
import { Row, Col, Divider, Space } from "antd"
import styled from "styled-components"
import {
	FacebookOutlined,
	InstagramOutlined,
	LinkedinOutlined,
} from "@ant-design/icons"

const Header = styled.h2`
	font-size: 16px;
`

const A = styled.a`
	font-size: 14px;
	color: grey;
`

const Footer: React.FC = () => {
	return (
		<Row gutter={2}>
			<Col xs={{ span: 12 }} md={{ span: 6 }}>
				<Header>Employers</Header>
				<Divider />
				<p>
					<A href="/login">Post a job for free</A>
				</p>
				<p>
					<A href="/login">Hire Staff</A>
				</p>
				<p>
					<A href="/login">Advertising Reach</A>
				</p>
				<p>
					<A href="/login">Employers Blog</A>
				</p>
			</Col>
			<Col xs={{ span: 12 }} md={{ span: 6 }}>
				<Header>Jobseekers</Header>
				<Divider />
				<p>
					<A href="/login">WorkClass CV</A>
				</p>
				<p>
					<A href="/login">Career Advice</A>
				</p>
				<p>
					<A href="/login">Jobs in Singapore</A>
				</p>
				<p>
					<A href="/login">Jobs in Logistics</A>
				</p>
				<p>
					<A href="/login">Jobs in Retail</A>
				</p>
				<p>
					<A href="/login">Jobs as a Drive</A>
				</p>
			</Col>
			<Col xs={{ span: 12 }} md={{ span: 6 }}>
				<Header>Workclass</Header>
				<Divider />
				<p>
					<A href="/login">About WorkClass</A>
				</p>
				<p>
					<A href="/login">Help Center</A>
				</p>
				<p>
					<A href="/login">Careers</A>
				</p>
				<p>
					<A href="/login">Marketing Reach</A>
				</p>
				<p>
					<A href="/login">All job categories</A>
				</p>
			</Col>
			<Col xs={{ span: 12 }} md={{ span: 6 }}>
				<Header>Site</Header>
				<Divider />
				<p>Follow Us</p>
				<Space size="small">
					<a href="https://www.facebook.com/WorkClassSG/">
						<FacebookOutlined
							style={{ fontSize: 30, color: "gray" }}
						/>
					</a>

					<a href="https://www.instagram.com/workclass.sg/">
					<InstagramOutlined
						style={{ fontSize: 30, color: "gray" }}
					/>
					</a>

					<a href="https://www.linkedin.com/company/workclass/">
						<LinkedinOutlined
							style={{ fontSize: 30, color: "gray" }}
						/>
					</a>
				</Space>
			</Col>
			<Col span={24}>
				<p style={{ textAlign: "center", marginTop: 30 }}>
					Workclass &copy; 2020
				</p>
			</Col>
		</Row>
	)
}

export default Footer
